<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2><template v-if="$route.params.id">Edit</template><template v-else>New</template> Portfolio Item</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle w3-red' style="margin-left:8px;" @click="exitPortfolioItem()">Exit</button>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Item</span><span v-if="saved">Item Saved</span></button>
        </div>
      </div>
      <div class="portfolioDetailGrid">
        <div>
          <div class="inputCard">
            <header class="w3-left-align">Main</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Title</label>
                <input v-model="portfolio.title" placeholder="My Portfolio Item" class="w3-input w3-border" />
              </div>
              <div class="input-row w3-padding-8">
                <label>Description</label>
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="portfolio.description"></tinymce-editor>
              </div>
            </div>
          </div>
          <!-- Images -->
          <div class="inputCard">
            <header class="w3-left-align">Images</header>
            <div class="content portfolioImagesGrid w3-padding-8">
              <div v-for="(image, index) in portfolio.images" :key="index">
                <div class="w3-center">
                  <img :src="(image.src && image.src !== '') ? image.src : 'https://levelsevenstudio.com/frontend/img/demos/real-estate/listings/listing-1.jpg'" style="width:100%;" />
                </div>
                <div class="cardRow w3-blue-grey" style="border-radius:0 0 5px 5px; padding:6px 6px 6px 10px;">
                  <label>Image {{index + 1}}</label>
                  <div class="w3-right-align">
                    <label :for="'portfolioFile' + index" class="w3-button w3-green" style="margin-top:0; font-size:10px; padding:5px 10px;"><i class="fa fa-upload"></i></label>
                    <input :id="'portfolioFile' + index" type="file" @change="uploadPortfolioImage($event.target.files, index)" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
                    <button class="w3-button w3-blue w3-round" style="padding:5px 10px; font-size:10px;" @click="choosePortfolioImage('images', index, portfolio.slug, 'portfolio')"><i class="fa fa-folder-open"></i></button>
                    <button class="w3-button w3-red w3-round" style="padding:5px 10px; font-size:10px;" @click="removeImage(index)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
              <!-- Add Image -->
              <div>
                <div class="w3-padding-bottom w3-round" style="border:1px solid #ccc; position:relative; height:249px; max-width:230px; margin:0 auto;" @click="addImage()">
                  <svg class="svg-circleplus" viewBox="0 0 100 100" style="height: 32px; stroke: #ccc; position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);">
                    <circle cx="50" cy="50" r="45" fill="none" stroke-width="4"></circle>
                    <line x1="32.5" y1="50" x2="67.5" y2="50" stroke-width="4"></line>
                    <line x1="50" y1="32.5" x2="50" y2="67.5" stroke-width="4"></line>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="inputCard">
          <header class="w3-left-align">Details</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Category</label>
              <v-select v-model="portfolio.category" label="title" :options="state.siteData.content.portfolio.categories">
                <template slot="option" slot-scope="option">
                  <div class="w3-container">
                    <p>
                      {{option.id}}. {{option.title}}
                    </p>
                  </div>
                </template>
              </v-select>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Client Name</label>
              <input v-model="portfolio.client" placeholder="Joe's Crab Shack" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Date</label>
              <input v-model="portfolio.date" type="date" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Tags</label>
              <input v-model="portfolio.tags" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Image Link</label>
              <input v-model="portfolio.imageLink" class="w3-input w3-border" />
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Status</label>
              <select class="w3-select w3-border" v-model="portfolio.status">
                <option value="active">Published</option>
                <option value="draft">Unpublished</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsportfoliodetail',
  data() {
    return {
      state: dataStore.state,
      portfolio: {
        id: 0,
        title: '',
        description: '',
        category: 0,
        imageLink: '',
        images: [],
        status: 'active',
        slug: ''
      },
      imageUpload: {
        src: '',
        alt: ''
      },
      saving: false,
      saved: false
    }
  },
  components: {
    'tinymce-editor': Editor
  },
  created() {
    this.initPortfolioItem()
    if (this.$route.params.url) {
      for (let savedPortfolioItem of this.state.siteData.content.portfolio.items) {
        if (savedPortfolioItem.url === this.$route.params.url) {
          this.portfolio = savedPortfolioItem
          if (this.portfolio.images.image1) {
            let oldimages = this.portfolio.images
            this.portfolio.images = [
              {
                src: oldimages.image1.src,
                alt: ''
              }
            ]
          }
          for (let savedCategory of this.state.siteData.content.portfolio.categories) {
            if (savedCategory.id === savedPortfolioItem.category) {
              this.portfolio.category = savedCategory
            }
          }
          break
        }
      }
    }
  },
  methods: {
    initPortfolioItem() {
      this.portfolio = {
        title: '',
        description: '',
        category: 0,
        images: [],
        status: 'active',
        url: ''
      }
    },
    addImage() {
      this.portfolio.images.push({alt:'',src:''})
    },
    removeImage(index) {
      this.portfolio.images.splice(index, 1)
    },
    choosePortfolioImage(property, index, slug, type) {
      this.state.filePickerPath = property
      this.state.filePickerIndex = index
      this.state.filePickerSlug = slug
      this.state.filePickerType = type
      dataStore.getFiles()
    },
    uploadPortfolioImage(files, which) {
      dataStore.uploadImage(files).then((path) => {
        this.portfolio.images[which].src = path
      })
    },
    saveContent() {
      this.portfolio.url = slug(this.portfolio.title)
      this.portfolio.category = this.portfolio.category.id
      let loopIndex = 0
      let found = false
      for (let portfolio of this.state.siteData.content.portfolio.items) {
        if (portfolio.url === this.portfolio.url) {
          if (!confirm('Portfolio Item with this Name already exists, overwrite?')) {
            return
          } else {
            found = true
            break
          }
        }
        loopIndex++
      }
      if (found) {
        this.state.siteData.content.portfolio.items[loopIndex] = this.portfolio
      } else {
        this.state.siteData.content.portfolio.items.push(this.portfolio)
      }
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.$router.replace('/cms/portfolio')
        }
      })
    },
    exitPortfolioItem() {
      this.initPortfolioItem()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .portfolioImagesGrid {display:grid; grid-template-columns: repeat(3, 1fr); grid-gap: 8px;}

  .buttons {text-align: right;}
  header.w3-left-align {padding-left:12px;}

  .portfolioDetailGrid {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
@media screen and (max-width:993px) {
  .portfolioImagesGrid {grid-template-columns: 1fr;}
  .portfolioDetailGrid {grid-template-columns: 1fr;}
  .headerGridCMS {grid-template-columns: 1fr 1fr;}
  /* .cardRow {grid-template-columns: 1fr;} */
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsPortfolioDetail.vue